import Logout from './container';

export default Logout;



// WEBPACK FOOTER //
// ./src/routes/Logout/index.js